import { Box, CircularProgress } from "@mui/material";
import { PersistedRecordingsList } from "./PersistedRecordingsList";
import { NativePlayer } from "features/videoPlayer/NativePlayer";
import { PlayerRef } from "features/videoPlayer/types/PlayerRef";
import { useEffect, useRef } from "react";
import { useAppSelector } from "app/hooks";
import { reIdSelectors } from "features/cases/caseViewer/reId/store/selectors";
import { VectorSearchDistanceSlider } from "./VectorSearchDistanceSlider";

export interface ObjectDetectionInsightsDialogContentProps {
    defaultVectorSearchDistance: number;
    onVectorSearchDistanceChanged: (newDistance: number) => void;
}

export function ObjectDetectionInsightsDialogContent(
    props: ObjectDetectionInsightsDialogContentProps,
) {
    const playerRef = useRef<PlayerRef>(null);

    const activePersistedRecordingToPlay = useAppSelector(
        reIdSelectors.selectActiveVectorSearchResultRecordToPlay,
    );

    const loadingVectorSearchResults = useAppSelector(
        reIdSelectors.selectLoadingVectorSearchResults,
    );

    useEffect(() => {
        if (!activePersistedRecordingToPlay) {
            return;
        }

        playerRef.current?.videoSetCurrentTime(
            activePersistedRecordingToPlay.firstSeenTimeInSeconds,
        );
    }, [activePersistedRecordingToPlay]);

    return (
        <>
            <Box
                component="nav"
                sx={{
                    width: 240,
                    borderRight: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                    bgcolor: "background.paper",
                    flexShrink: 0,
                }}
            >
                <VectorSearchDistanceSlider
                    defaultVectorSearchDistance={
                        props.defaultVectorSearchDistance
                    }
                    onVectorSearchDistanceChanged={
                        props.onVectorSearchDistanceChanged
                    }
                />

                {!loadingVectorSearchResults && <PersistedRecordingsList />}
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    p: 3,
                    overflowY: "auto",
                }}
            >
                {loadingVectorSearchResults && (
                    <CircularProgress title="Loading Re-Identification results..." />
                )}

                {!loadingVectorSearchResults &&
                    activePersistedRecordingToPlay && (
                        <NativePlayer
                            ref={playerRef}
                            url={`${activePersistedRecordingToPlay?.playbackUrl}?${"forward"}`}
                            playMode={"autoPlay"}
                            playSpeed={1}
                            enableAudio={true}
                            audioEnabledByDefault={false}
                            showControls={true}
                            enableOverlay={false}
                            sx={{
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    )}
            </Box>
        </>
    );
}
